import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
html, body, #root {
  height: 100%;
  
  @media screen and (max-width: 52em) {
    overflow-y: hidden;
  }
}
  body {
    color: #344f79;
    padding: 0;
    margin: 0;
    font-family: Poppins, sans-serif;
    -webkit-font-smoothing: antialiased;
    background: linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%);
  }
  input {
    font-family: Poppins, sans-serif;
  }
  a {
    color: #000;
  }

  .text-transition_inner {
    white-space: pre-wrap;
    text-align: center;
    height: 250px !important;
  }

.zindexTop {
  z-index:100;
}

.menyentry {
  cursor: pointer;
  
}
.menyentrydisabled {
  background: #d1d1d1 !important;
  color: #9d9d9d;
  cursor: not-allowed;
}

.LimitRteHeight {
  overflow-y: auto;
  max-height: 150px;
}

  .Select-input > input {
  caret-color: transparent;
  width: 100%;
  background: none transparent;
  border: 0 none;
  box-shadow: none;
  cursor: default;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  outline: none;
  line-height: 14px;
  /* For IE 8 compatibility */
  padding: 8px 0 12px;
  /* For IE 8 compatibility */
  -webkit-appearance: none;
}

.dropzone {
  &:focus {
    outline: none;
  }
}

.conversationbubble >a{
  color: white;
}

.slide-enter {
    transform: translateX(100vw);
    position: absolute;
    
}

/* Declare transition properties */
.slide-enter.slide-enter-active {
    transform: translateX(0);
    opacity: 1;
    transition: all 300ms linear 300ms;
}

/* EXIT TRANSITION */
.slide-exit {
    transform: translateX(0);
    opacity: 1;
    
}

.slide-exit.slide-exit-active {
    transform: translateX(-100vw);
    opacity: 0;
    transition: all 300ms linear
}

.chartAlertTooltip-color {
  opacity: 1!important;
  max-width: 30%;
}

.chartAlertTooltip-color.show {
  opacity: 1!important;
}
.__react_component_tooltip.show {
  .chartAlertTooltip-color {
  opacity: 1!important;
  }
}

header {
  display: block;
  width: 100%;
  padding: 1.75em 0;
  border-bottom: 1px solid #eee;
  background: #fff;
}

header #logo {
  font-size: 175%;
  text-align: center;
  color: #1a8fff;
  line-height: 1;
}

header #logo .icon {
  padding-right: .25em;
}

main {
  display: block;
  margin: 0 auto;
  margin-top: 5em;
  max-width: 50em;
}

/* .react-switch-selector-wrapper {
  width: fit-content !important;
}

.react-switch-selector-option {
  min-width: 150px;
  width: fit-content !important;
  padding: 0 10px;
}
.react-switch-selector-option-unselected::before {
  background: rgba(255,255,255,0.67);

} */
/* GRID */

.row {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.row-middle {
  align-items: center;
}

.col {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

.col-start {
  justify-content: flex-start;
  text-align: left;
  flex: initial;
}

.col-center {
  justify-content: center;
  text-align: center;
}

.col-end {
  justify-content: flex-end;
  text-align: right;
  flex: initial;
}


/* Calendar */

.calendar {
  display: block;
  position: relative;
  width: 100%;
}

.calendar .header {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 115%;
  padding: 1.5em 0;
  border-bottom: 1px solid #eee;
}

.calendar .header .icon {
  cursor: pointer;
  transition: .15s ease-out;
  color: #f9a394;
}

.calendar .header .icon:hover {
  /* transform: scale(1.75); */
  transition: .25s ease-out;
  color: #344f79;
}

.calendar .header .icon:first-of-type {
  margin-left: 1em;
}

.calendar .header .icon:last-of-type {
  margin-right: 1em;
}

.calendar .days {
  text-transform: uppercase;
  font-weight: 400;
  /* color: #ccc; */
  font-size: 70%;
  padding: .75em 0;
  border-bottom: 1px solid #eee;
}

.calendar .body .cell {
  position: relative;
  height: 5em;
  /* border-right: 1px solid #eee; */
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: 0.25s ease-out;
}

.calendar .body .cell:hover {
  background: #f9f9f9;
  transition: 0.5s ease-out;
  color: #344f79;
}

.calendar .body .selected {
  border-left: 1px solid transparent;
  border-image: linear-gradient(45deg, #1a8fff 0%,#53cbf1 40%);
  border-image-slice: 1;
  background-color: #344f79;
  color: white;
}

.calendar .body .row {
  border-bottom: 1px solid #eee;
}

.calendar .body .row:last-child {
  border-bottom: none;
}

.calendar .body .cell:last-child {
  border-right: none;
}

.calendar .body .cell .number {
  position: absolute;
  font-size: 14px;
  top: 3px;
  right: .75em;
  font-weight: 400;
  @media screen and (max-width: 52em) {
    left: 0;
    right: 0;
    width: 100%;
    text-align: center;
  }
}

.calendar .body .disabled {
  color: #ccc;
  pointer-events: none;
}
.calendar .body .past {
  color: #ccc;
  
}

.calendar .body .cell .bg {
  font-weight: 700;
  line-height: 1;
  color: #1a8fff;
  opacity: 0;
  font-size: 8em;
  position: absolute;
  top: -.2em;
  right: -.05em;
  transition: .25s ease-out;
  letter-spacing: -.07em;
}

.calendar .body .cell:hover .bg, .calendar .body .selected .bg  {
  opacity: 0.05;
  transition: .5s ease-in;
}

.calendar .body .col {
  flex-grow: 0;
  flex-basis: calc(100% / 7 - 1px);
  width: calc(100% / 7 - 1px);
}

.pac-container {
   top: 100%;
   background-color: hsl(0, 0%, 100%);
   border-radius: 4px;
   box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
   margin-bottom: 8px;
   margin-top: 8px;
   position: absolute;
   box-sizing: border-box;
   position: absolute!important;
   z-index: 1000;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
   max-height: 175px;
   padding-bottom: 4px;
   padding-top: 4px;
   overflow-y: auto;
   -webkit-overflow-scrolling: touch;
}

.pac-item {
   background-color: transparent;
   color: inherit;
   cursor: default;
   display: block;
   font-size: inherit;
   /* padding: 8px 12px 8px 0; */
   width: 100%;
   -webkit-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   box-sizing: border-box;
   &.active {
     background-color: #deebff;
   }

   cursor: default;
    padding: 8px 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    opacity: 0.75;
}

.pac-item-query {
   background-color: transparent;
   color: inherit;
   cursor: default;
   /* display: block; */
   font-size: inherit;
   /* padding: 8px 12px; */
   width: 100%;
   -webkit-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   box-sizing: border-box;
   &.active {
     background-color: #deebff;
   }

   cursor: default;
    /* padding: 0 4px 0 0; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}


  .calendly-inline-widget,
.calendly-inline-widget *,
.calendly-badge-widget,
.calendly-badge-widget *,
.calendly-overlay,
.calendly-overlay * {
	font-size: 16px;
	line-height: 1.2em
}

.calendly-inline-widget iframe,
.calendly-badge-widget iframe,
.calendly-overlay iframe {
	display: inline;
	width: 100%;
	height: 100%;
}

.calendly-popup-content {
	position: relative
}

.calendly-popup-content.mobile {
	-webkit-overflow-scrolling: touch;
	overflow-y: auto
}

.calendly-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	z-index: 9999;
	background-color: #a5a5a5;
	background-color: rgba(31, 31, 31, 0.4)
}

.calendly-overlay .calendly-close-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0
}

.calendly-overlay .calendly-popup {
	box-sizing: border-box;
	position: absolute;
	top: 50%;
	left: 50%;
	-webkit-transform: translateY(-50%) translateX(-50%);
	transform: translateY(-50%) translateX(-50%);
	width: auto;
	min-width: 350px;
	max-width: 1000px;
	height: 90%;
	max-height: 680px;
	/* background-color: #fff */
}

@media (max-width: 975px) {
	.calendly-overlay .calendly-popup {
		position: fixed;
		top: 50px;
		left: 0;
		right: 0;
		bottom: 0;
		-webkit-transform: none;
		transform: none;
		width: 100%;
	width: 100%;
		height: auto;
		min-width: 0;
		max-height: none
	}
}

.calendly-overlay .calendly-popup .calendly-popup-content {
	height: 100%
}

@media (max-width: 975px) {
	.calendly-overlay .calendly-popup .calendly-popup-content {
		background-color: #fff
	}
}

.calendly-overlay .calendly-popup .calendly-popup-close {
	position: absolute;
	top: 0;
	right: -24px;
	color: #fff;
	font-size: 24px;
	cursor: pointer
}

.calendly-overlay .calendly-popup .calendly-popup-close::before {
	content: "×"
}

@media (max-width: 975px) {
	.calendly-overlay .calendly-popup .calendly-popup-close {
		top: -50px;
		right: 14px;
		font-size: 40px
	}
}

.calendly-badge-widget {
	position: fixed;
	right: 20px;
	bottom: 15px;
	z-index: 9998
}

html.is-opaque {
  background: transparent !important;
}

.calendly-badge-widget .calendly-badge-content {
	display: table-cell;
	width: auto;
	height: 45px;
	padding: 0 30px;
	border-radius: 25px;
	box-shadow: rgba(0, 0, 0, 0.25) 0 2px 5px;
	font-family: sans-serif;
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	font-size: 14px;
	color: #fff;
	cursor: pointer
}

.calendly-badge-widget .calendly-badge-content.white {
	color: #666a73
}

.calendly-badge-widget .calendly-badge-content span {
	display: block;
	font-size: 12px
}

.spinner {
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
	text-align: center;
	z-index: -1
}

.spinner>div {
	display: inline-block;
	width: 18px;
	height: 18px;
	background-color: #e1e1e1;
	border-radius: 50%;
	vertical-align: middle;
	-webkit-animation: bouncedelay 1.4s infinite ease-in-out;
	animation: bouncedelay 1.4s infinite ease-in-out;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.spinner .bounce1 {
	-webkit-animation-delay: -0.32s;
	animation-delay: -0.32s
}

.spinner .bounce2 {
	-webkit-animation-delay: -0.16s;
	animation-delay: -0.16s
}

@-webkit-keyframes bouncedelay {
	0%,
	80%,
	100% {
		-webkit-transform: scale(0);
		transform: scale(0)
	}
	40% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes bouncedelay {
	0%,
	80%,
	100% {
		-webkit-transform: scale(0);
		transform: scale(0)
	}
	40% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

  .rc-steps-item-process .rc-steps-item-icon {
    background: #344f79 !important;
    border-color: #344f79 !important;
}

.rc-steps-item-title {
  font-weight: 500 !important;
}
a {
  color: #344f79;
}

@-webkit-keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(0.7, 0.7, 0.7);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.04, 1.03, 1.03);
  }

  80% {
    transform: scale3d(1.02, 1.02, 1.02);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(0.7, 0.7, 0.7);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.04, 1.03, 1.03);
  }

  80% {
    transform: scale3d(1.02, 1.02, 1.02);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.bounceIn {
  animation-duration: 1s;
  animation-name: bounceIn;
  -webkit-animation-name: bounceIn;
}

@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

  @keyframes fadeInUpFrom20 {
    from {
      opacity: 0;
      transform: translate3d(0, 20%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUpFrom20 {
    animation-name: fadeInUpFrom20;
  }

  @keyframes fadeInUpFrom30 {
    from {
      opacity: 0;
      transform: translate3d(0, 30%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUpFrom30 {
    animation-name: fadeInUpFrom30;
  }

  @keyframes fadeInUpFrom40 {
    from {
      opacity: 0;
      transform: translate3d(0, 40%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

@keyframes learnMoreBgFrames {
  from {background-color: transparent;}
  to {background-color: blue;}
}

  .fadeInUpFrom40 {
    animation-name: fadeInUpFrom40;
  }

.example-steps {
  position: absolute;
}

  @keyframes EnterFrames {
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
.example-enter {
  opacity: 0.5;
  transform: translate3d(50%, 0, 0);
}
.example-enter.example-enter-active {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  transition: all 500ms ease-in;
  
}

.example-exit {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.example-exit.example-exit-active {
  opacity: 0;
  transform: translate3d(-50%, 0, 0);
  transition: all 300ms ease-in;
}

.example-back-enter {
  opacity: 0;
  transform: translate3d(-50%, 0, 0);
}
.example-back-enter.example-back-enter-active {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  transition: all 500ms ease-in;
}

.example-back-exit {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.example-back-exit.example-back-exit-active {
  opacity: 0;
  transform: translate3d(50%, 0, 0);
  transition: all 300ms ease-in;
}


.moveList-enter {
    opacity: 0.01;
    transform: translate(-40px, 0)
}

.moveList-enter-active {
    opacity: 1;
    transform: translate(0, 0);
    transition: all 300ms ease-in;
}

.moveList-exit {
    opacity: 1;
    transform: translate(0, 0)
}

.moveList-exit-active {
    opacity: 0.01;
    transform: translate(40px, 0);
    transition: all 200ms ease-in;
}

.btnHamburger {
  background: linear-gradient(to right, rgba(248, 162, 148, 0.32) 50%, transparent 50%) !important;
  background-size: 200% 100% !important;
  background-position:right bottom !important;
  transition:all 0.3s ease;
}
.btnHamburger:hover {
  background-position:left bottom !important;
}

.expanded {
    position: absolute;
    top: 247px;
    z-index: 1;
    width: 100%;
  }

  .hideScrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hideScrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.vertical-timeline {
  margin: 12px !important;
  margin-left: 12px !important;
}

.vertical-timeline::before {
    content: '';
    position: absolute;
    top: 0;
    left: 18px;
    height: 100%;
    width: 4px;
    background: #344F7A
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  padding: 0;
}
.szh-menu__item--focusable {
  padding:0!important;
}

.vertical-timeline--lab .vertical-timeline .vertical-timeline--animate .vertical-timeline--one-column-left {
  margin: 12px !important;
  margin-left: 12px !important;
}

.vertical-timeline--lab::before {
    content: '';
    position: absolute;
    top: 0;
    left: 98px;
    height: 100%;
    width: 4px;
    background: #344F7A
}
.vertical-timeline--lab .vertical-timeline-element-content .vertical-timeline-element-date {
  position: absolute;
  left: -120px;
  top: 10px;
}

@keyframes react-loading-skeleton {
    100% {
        transform: translateX(100%);
    }
}

.react-loading-skeleton {
    --base-color: #ebebeb;
    --highlight-color: #f5f5f5;
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block; /* Enable animation */

    background-color: var(--base-color);

    width: 100%;
    border-radius: 0.25rem;
    display: inline-flex;
    line-height: 1;

    position: relative;
    overflow: hidden;
    z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
}

.react-loading-skeleton::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
        90deg,
        var(--base-color),
        var(--highlight-color),
        var(--base-color)
    );
    transform: translateX(-100%);

    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}

/* .DraftEditor-root {
  height:100%;
  overflow-y:scroll;
} */
/* .DraftEditor-editorContainer {
  margin-top:-13px;
} */
.react-toggle {
  touch-action: pan-x;

  display: inline-block;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
}

.react-toggle-screenreader-only {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.react-toggle--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  -webkit-transition: opacity 0.25s;
  transition: opacity 0.25s;
}

.react-toggle-track {
  width: 50px;
  height: 24px;
  padding: 0;
  border-radius: 30px;
  border: 5px solid #344F7A;
  background-color: transparent;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: transparent;
}

.react-toggle--checked .react-toggle-track {
  background-color: #344F7A;
}

.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: #344F7A;
}

.react-toggle-track-check {
  position: absolute;
  width: 14px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  left: 8px;
  opacity: 0;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-check {
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle-track-x {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  right: 10px;
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-x {
  opacity: 0;
}

.react-toggle-thumb {
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  position: absolute;
  top: 1px;
  left: 1px;
  width: 22px;
  height: 22px;
  border: 1px solid #4D4D4D;
  border-radius: 50%;
  background-color: #FAFAFA;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.react-toggle--checked .react-toggle-thumb {
  left: 27px;
  border-color: #344F7A;
}

.react-toggle--focus .react-toggle-thumb {
  /* -webkit-box-shadow: 0px 0px 3px 2px #344F7A;
  -moz-box-shadow: 0px 0px 3px 2px #344F7A;
  box-shadow: 0px 0px 2px 3px #344F7A; */
  box-shadow: transparent;
}

.react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
  /* -webkit-box-shadow: 0px 0px 5px 5px #344F7A;
  -moz-box-shadow: 0px 0px 5px 5px #344F7A; */
  box-shadow: transparent;
}

.react-switch-selector-option-unselected {
  position: relative;
  &::before {
        top: 3px;
        width: calc(100% - 6px);
        left: 3px;
        height: calc(100% - 6px);
        content: "";
        position: absolute;
  border: 1px solid #344F7A;
  border-radius: 20px;
  }
}






.calendarMini {
  display: block;
  position: relative;
  width: 300px;
}

.calendarMini .header {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 115%;
  padding: 1.5em 0;
  /* border-bottom: 1px solid #eee; */
}

.calendarMini .header .icon {
  cursor: pointer;
  transition: .15s ease-out;
  color: #f9a394;
}

.calendarMini .header .icon:hover {
  /* transform: scale(1.75); */
  transition: .25s ease-out;
  color: #344f79;
}

.calendarMini .header .icon:first-of-type {
  margin-left: 1em;
}

.calendarMini .header .icon:last-of-type {
  margin-right: 1em;
}

.calendarMini .days {
  text-transform: uppercase;
  font-weight: 400;
  /* color: #ccc; */
  font-size: 70%;
  padding: .75em 0;
  /* border-bottom: 1px solid #eee; */
}

.calendarMini .body .cell {
  position: relative;
  /* height: 5em; */
  /* border-right: 1px solid #eee; */
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: 0.25s ease-out;
  height: 42px;
}

.calendarMiniMin .body .cellMin {
  position: relative;
  height: 40px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: 0.25s ease-out;
  display:flex;
  align-items: center;
  justify-content: center;
}

.calendarMini .body .cell:hover {
  background: #f9f9f9;
  transition: 0.5s ease-out;
  border-radius: 50%;
  color: #344f79;
}

.calendarMini .body .selected {
    border-radius: 50%;
  background-color: #344f79;
  color: white;
}

.calendarMiniMin .body .selected {
  /* border-left: 1px solid transparent;
  border-image: linear-gradient(45deg, #1a8fff 0%,#53cbf1 40%);
  border-image-slice: 1;
  background-color: #344f79; */
  color: white;
}

.calendarMini .body .row {
  /* border-bottom: 1px solid #eee; */
}

.calendarMini .body .row:last-child {
  border-bottom: none;
}

.calendarMini .body .cell:last-child {
  border-right: none;
}

.calendarMiniMin .body .cellMin .number {
  font-size: 14px;
  font-weight: 400;
    text-align: center;
}

.calendarMini .body .cell .number {
  /* position: absolute; */
  font-size: 14px;
  /* top: 3px;
  right: .75em; */
  font-weight: 400;
  @media screen and (max-width: 52em) {
    /* left: 0;
    right: 0; */
    width: 100%;
    text-align: center;
  }
}

.calendarMiniMin .body .disabled {
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}
.calendarMiniMin .body .past {
  color: #ccc;
}
.calendarMini .body .disabled {
  color: #ccc;
  pointer-events: none;
  opacity: 0.6;
}

.calendarMini .body .past {
  opacity: 0.2;
}
.calendarMini .body .nextMonth {
  opacity: 0.6;
}

.calendarMini .body .cell .bg {
  font-weight: 700;
  line-height: 1;
  color: #1a8fff;
  opacity: 0;
  font-size: 8em;
  position: absolute;
  top: -.2em;
  right: -.05em;
  transition: .25s ease-out;
  letter-spacing: -.07em;
}

.calendarMini .rowDays{
width: calc(300px - 6px);
border: 0;
}
.calendarMini .body .cell:hover .bg, .calendarMini .body .selected .bg  {
  opacity: 0.05;
  transition: .5s ease-in;
}

.calendarMini .body .col {
  flex-grow: 0;
  flex-basis: calc(100% / 7 - 1px);
  width: calc(100% / 7 - 1px);
  display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}
`;
